import { JanglDateController as controller } from './controller.js';
import templateUrl from './template.html';

export const janglDateComponent = {
    templateUrl: templateUrl,
    controller: controller,
    bindings: {
        // pass in a refernce to the form form the parent for validation.
        form: '=',
        // label to use for the field
        label: '@',
        // model to bind
        model: '=',
        // element name
        name: '@',
        // Minimum year to be considered
        yearMin: '@',
        // Maximum year to be considered
        yearMax: '@',
        // Inverse the order of the years
        yearReverse: '@',
        // whether the field should be required, this will not be tested, unless validate is true
        required: '<',
        // whether the field should be disabled
        disabled: '<',
    }
};



// WEBPACK FOOTER //
// ./app/jangl/jangl-date/component.js